import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { 
  Table, 
  Card, 
  Button, 
  Modal, 
  Form, 
  Input, 
  message,
  Switch,
  Space 
} from 'antd';
import { areaService } from '../../services/areaService';

const Areas: React.FC = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [areas, setAreas] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchAreas();
  }, []);

  const fetchAreas = async () => {
    try {
      setLoading(true);
      const response = await areaService.getAll();
      setAreas(response.data);
    } catch (error) {
      message.error(t('areas.loadError'));
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = async (values) => {
    try {
      await areaService.create(values);
      message.success(t('areas.createSuccess'));
      setIsModalVisible(false);
      form.resetFields();
      fetchAreas();
    } catch (error) {
      message.error(t('areas.createError'));
    }
  };

  const columns = [
    {
      title: t('areas.columnId'),
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: t('areas.columnCode'),
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: t('common.name'),
      dataIndex: 'area',
      key: 'area',
    },
    {
      title: t('common.status'),
      dataIndex: 'selected',
      key: 'selected',
      render: (selected) => (
        <Switch checked={selected} disabled />
      )
    },
    {
      title: t('common.actions'),
      key: 'actions',
      render: (_, record) => (
        <Space>
          
          <Button type="default" danger size="small">
            ...
          </Button>
        </Space>
      )
    }
  ];

  return (
    <>
      <Card 
        title={t('areas.cardTitle')} 
        
      >
        <Table 
          columns={columns}
          dataSource={areas}
          loading={loading}
          rowKey="id"
        />
      </Card>

      
    </>
  );
};

export default Areas;